<template>
  <span>
    {{ translatedValue }}
  </span>
</template>

<script>
import { formatNumber } from 'util/utils';

export default {
  name: 'QuantityCol',
  props: {
    tableProps: {},
    colInfo: {},
  },
  computed: {
    translatedValue() {
      return formatNumber(
        _.get(this.tableProps.row, this.colInfo.prop),
        'decimal'
      );
    },
  },
};
</script>

<style scoped></style>
